import { render, staticRenderFns } from "./MicrophonePermission.vue?vue&type=template&id=74f5ae8b&scoped=true&"
import script from "./MicrophonePermission.vue?vue&type=script&lang=js&"
export * from "./MicrophonePermission.vue?vue&type=script&lang=js&"
import style0 from "./MicrophonePermission.vue?vue&type=style&index=0&id=74f5ae8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f5ae8b",
  null
  
)

export default component.exports